import { ReactNode } from 'react';
import { useFeatureFlags } from '@/contexts/FeatureFlagContext';
import { useAuth } from '@/contexts/AuthContext';
import MaintenancePage from '@/pages/MaintenancePage';

export function MaintenanceGate({ children }: { children: ReactNode }) {
  const { maintenance, isLoading } = useFeatureFlags();
  const { isAdmin } = useAuth();

  // Admins always bypass maintenance
  if (isAdmin) return <>{children}</>;

  // Show blank screen while loading to prevent FOUC
  if (isLoading) {
    return <div className="min-h-screen bg-[#0a1628]" />;
  }

  // Show maintenance page if enabled
  if (maintenance.enabled) {
    return <MaintenancePage maintenance={maintenance} />;
  }

  return <>{children}</>;
}
